import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "view__header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "view__header_title" }, "Экспорт заказов")
], -1)
const _hoisted_2 = { class: "tabs is-toggle" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", null, "Экспорт", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", null, "История", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "export-file"
}
const _hoisted_8 = {
  key: 1,
  class: "view-table box"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Export = _resolveComponent("Export", true)!
  const _component_History = _resolveComponent("History")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", {
          class: _normalizeClass(["has-background-white", { 'is-active': _ctx.tab === _ctx.tabNames.EXPORT }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.tab = _ctx.tabNames.EXPORT))
        }, _hoisted_4, 2),
        _createElementVNode("li", {
          class: _normalizeClass(["has-background-white", { 'is-active': _ctx.tab === _ctx.tabNames.HISTORY }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tab = _ctx.tabNames.HISTORY))
        }, _hoisted_6, 2)
      ])
    ]),
    (_ctx.tab === _ctx.tabNames.EXPORT)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_Export)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_History)
        ]))
  ], 64))
}